import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Dust from '../components/Dust'

const CardBox = styled.div`
  width: 100%;
  margin: 16px;
  font-size: 0.75em;
  flex-basis: calc(50% - 36px);
  text-decoration: none;
  color: #000;
  position: relative;
  display: flex;

  a, a:visited {
    color: #000;
  }

  p {
    background-color: #E7DAB0;
    display: inline-block;
    padding: 4px 8px;
    border-radius: 2px;
    margin-left: 8px;
    margin-right: 8px;
    color: #000;
  }

  @media (min-width: 650px) {
    flex-basis: calc(25% - 36px);
  }

  @media (min-width: 900px) {
    flex-basis: calc(16.66% - 32px);
    font-size: 0.875em;
  }
`

const Content = styled.div`
  width: 100%;
  position: relative;
  transition: all 0.75s ease;
  background-color: #8A442B;
  box-shadow: 0px 0px 8px rgba(0,0,0,.4);
  border-right: 4px solid #562B1B;
  border-radius: 0 12px 12px 0;
  padding-top: 16px;

  :hover {
    box-shadow: 0px 0px 28px rgba(0,0,0,.9);
    transform: translateY(-3px);
  }
`

const Image = styled.div`
  margin: 16px auto 8px;
  border: 2px solid #562B1B;
  border-radius: 100%;
  width: 70%;
  height: 0;
  padding-top: 70%;
  background: url(${props => props.image}) center center no-repeat, #8A442B;
  background-size: cover;
  background-blend-mode: luminosity;
`

const XButton = styled.button`
  background: none;
  border: none;
  color: #E7DAB0;
  font-size: 1.75em;
  font-family: 'PT Mono';
  position: absolute;
  top: 2px;
  right: 2px;
  cursor: pointer;
`

const Close = (props) => {
  const remove = props.remove
  if (remove) {
    return <XButton onClick={ props.onClick }>x</XButton>
  } else {
    return null
  }
}

const Card = (props) => {
  const dusted = props.dusted

  const contentStyles = {
    opacity: dusted ? 0 : 1
  }

  return (
    <CardBox>
      <Dust toDust={ props.toDust } dusted={ props.dusted }/>
      <Content style={contentStyles}>
        <Close remove={ props.remove } onClick={ props.onClick }/>
        <Link to={`/subject/${props.id}`}>
          <div>
            <Image image={ props.img } alt={ props.name } />
            <p>{ props.name }</p>
          </div>
        </Link>
      </Content>
    </CardBox>
  )
}

export default Card
